import { useDataValue } from 'Simple/Data.js'

/** @type {import('Simple/types.js').useDataConfiguration} */
export default function useDataConfiguration(props, data) {
  let person_id = useDataValue({
    context: 'form',
    path: 'action.recipient_id',
    viewPath: props.viewPath,
  })

  return {
    variables: {
      person_id,
    },
    pause: !person_id,
  }
}
